<template>
  <main>
    <component :is="component">
      <component :is="keyboardComponent" slot="keyboard"></component>
    </component>
  </main>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    StandardKeyboard: () => import(`components/keyboards/StandardKeyboard.vue`),
    ExternalKeyboard: () => import(`components/keyboards/ExternalKeyboard.vue`),
    MobileOnscreenKeyboard: () => import(`components/keyboards/MobileOnscreenKeyboard.vue`)
  },
  computed: {
    ...mapGetters('application', ['needsToChooseKeyboard']),
    component() {
      return () => import(`@/${this.$route.query.path}.vue`);
    },
    ...mapState('application', {
      isMobile: state => state.device.isMobile
    }),
    ...mapGetters('application', ['usingExternalKeyboard']),
    keyboardComponent() {
      const { isMobile, usingExternalKeyboard } = this;
      let name = 'StandardKeyboard';
      if (isMobile) {
        name = usingExternalKeyboard ? 'ExternalKeyboard' : 'MobileOnscreenKeyboard';
      }

      return name;
    }
  },

  mounted() {
    if (this.needsToChooseKeyboard) {
      const query = { return: this.$router.app._route.path, query: this.$router.app._route.query }; // eslint-disable-line
      this.$router.replace({ path: '/component-tester-keyboard-select', query });
    }
  }
};
</script>

<style lang="scss" scoped></style>
